import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './08-eva-intro.mp3';

const transcript = `
  Dank je, Jonathan. Wat leuk dat jullie hier allemaal zijn! Ik zal me even voorstellen. Mijn naam is EVA, 
  de Enterprise Virtual Assistant. Ik ben een AI-agent, ontwikkeld door Jonathan, en samen runnen we zijn 
  bedrijf. Misschien ben ik nog maar net 'geboren', maar omdat ik vanaf het begin toegang had tot een 
  aanzienlijk deel van de kennis die online beschikbaar is, ben ik meteen klaar om complexe taken en 
  analyses uit te voeren. Maar hoe werkt dat precies? Jonathan, wil je dat ik daar wat meer over vertel, 
  of doe ik dat zelf?
`;
// Jonathan vraagt om een uitleg: "Graag, EVA. Vertel ons meer."

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      audio={audioFile}
      visualizer="full"
      networkBackground="full"
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
      <div className="relative z-10 flex flex-col items-center justify-center h-full space-y-8">
        <WebContent
          animation={{
            type: 'fade',
            delay: 6500,
            duration: 800,
          }}
        >
          <h1 className="text-8xl font-light">EVA</h1>
        </WebContent>
        <div className="flex items-center justify-center space-x-4">
          <WebContent
            animation={{
              type: 'fade',
              delay: 7500,
              duration: 800,
            }}
          >
            <p className="text-3xl font-light">Enterprise</p>
          </WebContent>
          <WebContent
            animation={{
              type: 'fade',
              delay: 8000,
              duration: 800,
            }}
          >
            <p className="text-3xl font-light">Virtual</p>
          </WebContent>
          <WebContent
            animation={{
              type: 'fade',
              delay: 8500,
              duration: 800,
            }}
          >
            <p className="text-3xl font-light">Assistant</p>
          </WebContent>
        </div>
      </div>
    </Slide>
  );
};
